<template>
  <organism-create-edit-backup
    v-if="!isDataLoading"
    v-model="backupData"
    :backupDataOriginal="backupDataOriginal"
    :vmList="vmList"
    :repositoryList="repositoryList"
    :backupList="backupList"
    :vmInventoryList="vmInventoryList"
    :fields="fields"
    :items="restorePointList"
    @changeVm="changeVmToApi"
    @onClickCreate="onClickCreate"
    @editBackup="editBackupToApi"
    @startBackup="startBackupToApi"
    @stopBackup="stopBackupToApi"
    @enableBackup="enableBackupToApi"
    @disableBackup="disableBackupToApi"
    @confirmRestore="confirmRestoreToApi"
  ></organism-create-edit-backup>
</template>

<script>
import { DateTime } from "luxon"
import {
  getVeeamServer,
  getRepositoryStatusList,
  getBackupList,
  getBackupById,
  getBackupStateById,
  getVmInventoryListByName,
  createBackup,
  editBackup,
  startBackup,
  stopBackup,
  enableBackup,
  disableBackup,
  getRestorePoint,
  getBackupObjectList,
  restoreEntireVm,
} from "@/api/api-module3"
import OrganismCreateEditBackup from "@/components/organisms/backupManagement/OrganismCreateEditBackup.vue"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import { mapGetters } from "vuex"
export default {
  name: "CreateEditBackup",
  components: { OrganismCreateEditBackup },
  mixins: [mixins, mixinsValidator],
  data() {
    return {
      backupData: {
        id: "",
        status: "",
        name: "",
        description: "",
        vmServer: "",
        server: "",
        isHighPriority: true,
        repository: "",
        retention: 90,
        retry: 0,
        retryDelay: 10,

        schedule: "",
        weekday: [],
        time: "",

        month: [],
        weekOrder: "First",
        monthWeekday: "",
        monthTime: "",

        periodic: "",
        amount: 1,
      },

      backupDataOriginal: {},
      vmList: [],
      repositoryList: [],
      backupList: [],
      vmInventoryList: [],
      restorePointList: [],
      // filterData: {
      //   currentPage: 1,
      //   totalCount: 0,
      // },
      backupState: "",
      inventory: "",
      fields: [
        {
          key: "name",
          label: "NAME",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
        {
          key: "platform",
          label: "PLATFORM",
          thClass: "w-200px",
          tdClass: "w-200px",
        },
        {
          key: "creationTime",
          label: "BACKUP TIME",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
        {
          key: "restoreIcon",
          label: "RESTORE",
          thClass: "w-150px text-center",
          tdClass: "w-150px text-center",
        },
      ],
      isDataLoading: true,
    }
  },
  computed: {
    ...mapGetters("app", ["getCurrentServerVeeam"]),

    currentServerVeeam() {
      return this.getCurrentServerVeeam
    },
    backupId() {
      return this.$route.params.id
    },
  },
  watch: {
    currentServerVeeam() {
      this.getServerListFromApi()
      this.getRepositoryListFromApi()
      this.getRestoreListFromApi()
    },
  },
  async mounted() {
    this.showLoading(true)
    this.isDataLoading = true
    this.getBackupDetail()
    setTimeout(async () => {
      if (this.hasString(this.currentServerVeeam.id)) {
        await this.getServerListFromApi()
        await this.getRepositoryListFromApi()
        if (this.backupId) {
          await this.getBackupByIdFromApi(this.backupId)
          await this.getBackupListFromApi()
          await this.getRestoreListFromApi()
        }
      }
      this.showLoading(false)
      this.isDataLoading = false
    }, 500)
  },
  methods: {
    onClickCreate() {
      let vmObject = []
      this.backupData.server.forEach((inventory) => {
        vmObject.push({
          objectId: inventory.objectId,
          hostName: inventory.hostName,
          name: inventory.name,
          type: inventory.type,
        })
      })
      const request = {
        name: this.backupData.name,
        description: this.backupData.description,
        type: "Backup",
        isHighPriority: this.backupData.isHighPriority,
        virtualMachines: {
          includes: vmObject,
        },
        storage: {
          backupRepositoryId: this.backupData.repository.id,
          backupProxies: {
            autoSelection: true,
          },
          retentionPolicy: {
            type: "Days",
            quantity: Number(this.backupData.retention),
          },
          guestProcessing: {
            appAwareProcessing: {
              isEnabled: false,
            },
            guestFSIndexing: {
              isEnabled: false,
            },
          },
        },
        schedule: {
          runAutomatically: this.hasObjectValue(this.backupData.schedule),
          retry: {
            isEnabled: Number(this.backupData.retry) > 0,
            retryCount:
              Number(this.backupData.retry) > 0
                ? Number(this.backupData.retry)
                : 1,
            awaitMinutes: Number(this.backupData.retryDelay),
          },
          daily: {
            isEnabled: this.backupData.schedule === "Daily",
            dailyKind: "SelectedDays",
            localTime:
              this.backupData.schedule === "Daily"
                ? this.backupData.time
                : null,
            days: this.backupData.weekday,
          },
          monthly: {
            isEnabled: this.backupData.schedule === "Monthly",
            dayOfWeek: this.backupData.monthWeekday,
            dayNumberInMonth: this.backupData.weekOrder,
            localTime:
              this.backupData.schedule === "Monthly"
                ? this.backupData.monthTime
                : null,
            months: this.backupData.month,
          },
          periodically: {
            isEnabled: this.backupData.schedule === "Periodic",
            periodicallyKind: this.backupData.periodic,
            frequency: Number(this.backupData.amount),
          },
          afterThisJob: {
            isEnabled: this.backupData.schedule === "After Job",
            jobName: this.backupData.job.name,
          },
        },
      }
      const duplicateName = this.backupList.find((backup) => {
        return backup.name == this.backupData.name
      })
      if (duplicateName) {
        this.toastError(`${this.backupData.name} is already use`)
      } else {
        this.createVeeamBackupToApi(request)
      }
    },

    getBackupDetail() {
      this.backupDataOriginal = JSON.parse(JSON.stringify(this.backupData))
    },

    async getServerListFromApi() {
      this.vmList = []
      const baseFilter = { veeamId: this.currentServerVeeam.id }
      await getVeeamServer(baseFilter)
        .then((response) => {
          response.data.forEach((server) => {
            if (server.type === "ViHost") {
              this.vmList.push({
                id: server.id,
                ip: server.name,
              })
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    editBackupToApi() {
      let vmObject = []
      this.backupData.server.forEach((inventory) => {
        vmObject.push({
          inventoryObject: {
            objectId: inventory.objectId,
            hostName: inventory.hostName,
            name: inventory.name,
            type: inventory.type,
          },
        })
      })
      const request = {
        name: this.backupData.name,
        description: this.backupData.description,
        type: "Backup",
        isHighPriority: this.backupData.isHighPriority,
        virtualMachines: {
          includes: vmObject,
        },
        storage: {
          backupRepositoryId: this.backupData.repository.id,
          backupProxies: {
            autoSelection: true,
          },
          retentionPolicy: {
            type: "Days",
            quantity: Number(this.backupData.retention),
          },
          guestProcessing: {
            appAwareProcessing: {
              isEnabled: false,
            },
            guestFSIndexing: {
              isEnabled: false,
            },
          },
        },
        schedule: {
          runAutomatically: this.hasObjectValue(this.backupData.schedule),
          retry: {
            isEnabled: Number(this.backupData.retry) > 0,
            retryCount:
              Number(this.backupData.retry) > 0
                ? Number(this.backupData.retry)
                : 1,
            awaitMinutes: Number(this.backupData.retryDelay),
          },
          daily: {
            isEnabled: this.backupData.schedule === "Daily",
            dailyKind: "SelectedDays",
            localTime:
              this.backupData.schedule === "Daily"
                ? this.backupData.time
                : null,
            days: this.backupData.weekday,
          },
          monthly: {
            isEnabled: this.backupData.schedule === "Monthly",
            dayOfWeek: this.backupData.monthWeekday,
            dayNumberInMonth: this.backupData.weekOrder,
            localTime:
              this.backupData.schedule === "Monthly"
                ? this.backupData.monthTime
                : null,
            months: this.backupData.month,
          },
          periodically: {
            isEnabled: this.backupData.schedule === "Periodic",
            periodicallyKind: this.backupData.periodic,
            frequency: Number(this.backupData.amount),
          },
          afterThisJob: {
            isEnabled: this.backupData.schedule === "After Job",
            jobName: this.backupData.job.name,
          },
        },
      }
      this.editVeeamBackupFromApi(request)
    },

    async getRepositoryListFromApi() {
      this.showLoading(true)
      this.repositoryList = []
      const baseFilter = { veeamId: this.currentServerVeeam.id }
      await getRepositoryStatusList(baseFilter)
        .then((response) => {
          response.data.forEach((repository) => {
            this.repositoryList.push({
              id: repository.id,
              label: `${repository.name} (${repository.path})`,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getBackupListFromApi(filter) {
      this.showLoading(true)
      this.backupList = []
      const baseFilter = {
        veeamId: this.currentServerVeeam.id,
      }
      await getBackupList(baseFilter)
        .then((response) => {
          response.data.data.forEach((backup) => {
            if (filter !== backup.name) {
              this.backupList.push({
                id: backup.id,
                name: backup.name,
                status: backup.status,
              })
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getBackupStateByIdFromApi(backupStateId) {
      this.showLoading(true)
      const baseFilter = { veeamId: this.currentServerVeeam.id }
      this.backupState = ""
      await getBackupStateById(backupStateId, baseFilter)
        .then((response) => {
          this.backupState = response.status
        })
        .finally(() => this.showLoading(false))
    },

    async getBackupByIdFromApi(backupId) {
      this.showLoading(true)
      const baseFilter = { veeamId: this.currentServerVeeam.id }
      let responseData = []
      let amountTemp = 0
      this.clearSchedule()
      this.backupData.server = ""
      // API
      await getBackupById(backupId, baseFilter).then(async (response) => {
        // copy response
        responseData = response
        this.backupData.id = response.id
        this.backupData.name = response.name
        this.backupData.description = response.description
        this.backupData.isHighPriority = response.isHighPriority
        // Repository
        this.backupData.repository = this.repositoryList.find((repository) => {
          return repository.id == response.storage.backupRepositoryId
        })
        //Server
        this.backupData.vmServer = this.vmList.find((vm) => {
          return (
            vm.ip ==
            response.virtualMachines.includes[0].inventoryObject.hostName
          )
        })
        // Schedule
        if (response.schedule.runAutomatically) {
          const data = response.schedule
          // Daily
          if (data.daily.isEnabled) {
            this.backupData.schedule = "Daily"
            this.backupData.weekday = data.daily.days.map((day) => {
              return this.toPascalCase(day)
            })
            this.backupData.time = data.daily.localTime
          }
          // Monthly
          else if (data.monthly.isEnabled) {
            this.backupData.schedule = "Monthly"
            this.backupData.weekOrder = data.monthly.dayNumberInMonth
            this.backupData.monthWeekday = this.toPascalCase(
              data.monthly.dayOfWeek
            )
            this.backupData.month = data.monthly.months.map((month) => {
              return this.toPascalCase(month)
            })
            this.backupData.monthTime = data.monthly.localTime
          }
          // Periodic
          else if (data.periodically.isEnabled) {
            this.backupData.schedule = "Periodic"
            this.backupData.periodic = data.periodically.periodicallyKind
            amountTemp = data.periodically.frequency
          }
          // After Job
          else if (data.afterThisJob.isEnabled) {
            this.backupData.schedule = "After Job"
            this.backupData.job = this.backupList.find((backup) => {
              return (backup.name = data.afterThisJob.jobName)
            })
          }
          // Retry
          if (response.schedule.retry.isEnabled) {
            this.backupData.retry = response.schedule.retry.retryCount
            this.backupData.retryDelay = response.schedule.retry.awaitMinutes
          }
        }
        await this.getBackupListFromApi()
        this.backupState = this.backupList.find((backup) => {
          return backup.name == this.backupData.name
        })
        this.backupData.status = this.backupState.status.toUpperCase()
        // Remove dupicate
        await this.getBackupListFromApi(this.backupData.name)
      })
      await this.getVmInventoryFromApi(this.backupData.vmServer.ip)
      this.backupData.server = responseData.virtualMachines.includes.map(
        (vm) => {
          return this.vmInventoryList.find(
            (list) => list.objectId === vm.inventoryObject.objectId
          )
        }
      )
      // Watcher clear amount if periodic change
      this.backupData.amount = amountTemp
      this.backupDataOriginal = JSON.parse(JSON.stringify(this.backupData))
    },

    async getVmInventoryFromApi(inventory) {
      this.showLoading(true)
      this.vmInventoryList = []
      const baseFilter = { veeamId: this.currentServerVeeam.id }
      const vmName = inventory
      await getVmInventoryListByName(baseFilter, vmName)
        .then((response) => {
          response.data.forEach((vmObject) => {
            if (
              !this.vmInventoryList.some(
                (vm) => vm.objectId === vmObject.inventoryObject.objectId
              )
            ) {
              this.vmInventoryList.push({
                objectId: vmObject.inventoryObject.objectId,
                hostName: vmObject.inventoryObject.hostName,
                name: vmObject.inventoryObject.name,
                type: vmObject.inventoryObject.type,
                size: vmObject.size,
                label: `${vmObject.inventoryObject.name} (${vmObject.size})`,
              })
            }
          })
        })
        .catch((error) => {
          if (error.toString().includes('timeout')) {
            this.toastError("Get Veeam Inventory Timeout")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async changeVmToApi(inventory) {
      this.inventory = inventory
      if (!this.backupData.status) {
        await this.getVmInventoryFromApi(inventory)
      }
    },

    async createVeeamBackupToApi(request) {
      this.showLoading(true)
      await createBackup(request, this.currentServerVeeam.id)
        .then(async (response) => {
          if (response.status === "ok") {
            this.$router.push("/backup-management/backup")
            this.toastSuccess("Created successfully")
          } else {
            this.toastError("Created failed")
          }
        })
        .catch(() => {
          this.toastError("Created failed")
        })
        .finally(() => this.showLoading(false))
    },

    async editVeeamBackupFromApi(request) {
      this.showLoading(true)
      await editBackup(request, this.backupId, this.currentServerVeeam.id)
        .then(async (response) => {
          if (response.status === "ok") {
            this.$router.push("/backup-management/backup")
            this.toastSuccess("Edit successfully")
          } else {
            this.toastError("Edit failed")
          }
        })
        .catch(() => {
          this.toastError("Edit failed")
        })
        .finally(() => this.showLoading(false))
    },

    async startBackupToApi() {
      this.showLoading(true)
      const request = this.backupId
      await startBackup(request, this.currentServerVeeam.id)
        .then((response) => {
          if (response.status === "ok") {
            this.showLoading(true)
            setTimeout(() => {
              this.showLoading(false)
              this.toastSuccess("Start backup successfully")
              this.getBackupByIdFromApi(this.backupId)
            }, 15000)
          } else {
            this.toastError("Start backup failed")
          }
        })
        .catch(() => {
          this.toastError("Start backup failed")
        })
    },

    async stopBackupToApi() {
      this.showLoading(true)
      const request = this.backupId
      await stopBackup(request, this.currentServerVeeam.id)
        .then((response) => {
          if (response.status === "ok") {
            this.showLoading(true)
            setTimeout(() => {
              this.showLoading(false)
              this.toastSuccess("Stop backup successfully")
              this.getBackupByIdFromApi(this.backupId)
            }, 15000)
          } else {
            this.toastError("Stop backup failed")
          }
        })
        .catch(() => {
          this.toastError("Stop backup failed")
        })
    },

    async enableBackupToApi() {
      this.showLoading(true)
      const request = this.backupId
      await enableBackup(request, this.currentServerVeeam.id)
        .then(async (response) => {
          if (response.status === "ok") {
            this.toastSuccess("Enable backup successfully")
            await this.getBackupByIdFromApi(this.backupId)
          } else {
            this.toastError("Enable backup failed")
          }
        })
        .catch(() => {
          this.toastError("Enable backup failed")
        })
    },

    async disableBackupToApi() {
      this.showLoading(true)
      const request = this.backupId
      await disableBackup(request, this.currentServerVeeam.id)
        .then(async (response) => {
          if (response.status === "ok") {
            this.toastSuccess("Disable backup successfully")
            await this.getBackupByIdFromApi(this.backupId)
          } else {
            this.toastError("Disable backup failed")
          }
        })
        .catch(() => {
          this.toastError("Disable backup failed")
        })
    },

    async getRestoreListFromApi() {
      this.showLoading(true)
      this.restorePointList = []
      let filterRestoreObject = {
        veeamId: this.currentServerVeeam.id,
        BackupId: "",
        // Page: this.filterData.currentPage,
        // PageSize: 10,
      }

      const filterBackupObject = {
        veeamId: this.currentServerVeeam.id,
        JobIdFilter: this.backupData.id,
      }

      await getBackupObjectList(filterBackupObject)
        .then((response) => {
          if (response) {
            filterRestoreObject.BackupId = response.data.data[0].id
          }
        })
        .finally(() => this.showLoading(false))

      await getRestorePoint(filterRestoreObject)
        .then((response) => {
          if (response) {
            // this.filterData.totalCount = response.pagination?.total
            this.restorePointList = response.data.data.map((restorePoint) => {
              return {
                id: restorePoint.id,
                name: restorePoint.name,
                creationTime: {
                  date: DateTime.fromISO(restorePoint.creationTime).toFormat(
                    "dd/MM/yyyy"
                  ),
                  time: DateTime.fromISO(restorePoint.creationTime).toFormat(
                    "HH:mm:ss"
                  ),
                },
                platform: restorePoint.platformName,
              }
            })
          }
        })
        .finally(() => this.showLoading(false))
    },

    async confirmRestoreToApi(restoreObjectId) {
      this.showLoading(true)

      const request = {
        objectRestorePointId: restoreObjectId,
        type: "OriginalLocation",
        secureRestore: {
          enableAntivirusScan: true,
        },
        powerUp: true,
      }

      await restoreEntireVm(request, this.currentServerVeeam.id)
        .then((response) => {
          if (response)
            this.toastSuccess(`Restore ${response.data.name} successfully`)
          this.$router.push("/backup-management/backup")
        })
        .catch(() => {
          this.toastError("Restore Failed")
        })
        .finally(() => this.showLoading(false))
    },

    toPascalCase(words) {
      return words
        ? words.replace(/\w+/g, function (w) {
            return w[0].toUpperCase() + w.slice(1).toLowerCase()
          })
        : ""
    },

    clearSchedule() {
      this.backupData.schedule = ""
      this.backupData.weekday = []
      this.backupData.time = ""
      this.backupData.month = []
      this.backupData.weekOrder = "First"
      this.backupData.Weekday = ""
      this.backupData.monthTime = ""
      this.backupData.periodic = ""
      this.backupData.amount = 1
      this.backupData.job = ""
    },
  },
}
</script>

<style lang="scss" scoped></style>
